// extracted by mini-css-extract-plugin
export default {"root":"B9Hege","glow":"oQs72m","bw":"pZTzQR","text":"_jdUsy","rounded":"d5NwmP","circular":"E6MZ6x"};